var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('page-header',{attrs:{"title":_vm.lang.help,"info":_vm.lang.helpInfo}}),_vm._v(" "),_c('div',{class:['font-weight-light', 'meta-description'],domProps:{"innerHTML":_vm._s(_vm.topics)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ad3e58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/help.vue
// module id = null
// module chunks = 